<script>
    import SlideUpDown from 'vue-slide-up-down'

    export default {
        props: ['entry', 'label'],
        components: {
            SlideUpDown,
        },

        data() {
            return {
                open: false,
            }
        },
        methods: {
            trackingQuestion(){
                var vm = this;
                if (vm.open){
                    console.log(vm.label);
                    var dataObject = {
                        'event': 'faq_opened',
                        'category': 'click',
                        'label': vm.label,
                    };
                    console.log(dataObject);
                    if(typeof dataLayer != 'undefined'){
                        dataLayer.push(dataObject);
                    }
                }
            },
        },
        mounted(){
            var vm = this;
            var hash = (window.location.hash);
            if (hash == '#question-' + vm.entry){
                vm.open = true;
            }
        }
    }
</script>
